import { styled } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

export const Wrapper = styled(Box)`
  /* CSS Custom Properties Registration */
  @property --glow-deg {
    syntax: '<angle>';
    inherits: true;
    initial-value: -90deg;
  }

  @property --clr-1 {
    syntax: '<color>';
    inherits: true;
    initial-value: red;
  }

  @property --clr-2 {
    syntax: '<color>';
    inherits: true;
    initial-value: yellow;
  }

  @property --clr-3 {
    syntax: '<color>';
    inherits: true;
    initial-value: green;
  }

  @property --clr-4 {
    syntax: '<color>';
    inherits: true;
    initial-value: blue;
  }

  @property --clr-5 {
    syntax: '<color>';
    inherits: true;
    initial-value: purple;
  }

  /* Glowing Border Styles */
  --gradient-glow: var(--clr-1), var(--clr-2), var(--clr-3), var(--clr-4),
    var(--clr-5), var(--clr-1);

  margin-block: 1rem;
  padding: 1rem;
  max-width: 100%;

  border: var(--border-width, 3px) solid transparent;
  border-radius: 8px;
  background:
    linear-gradient(var(--surface, white) 0 0) padding-box,
    conic-gradient(from var(--glow-deg), var(--gradient-glow)) border-box;

  position: relative;
  isolation: isolate;

  animation: glow 10s infinite linear;

  textarea {
    border: none;
    background: transparent;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizes[2]};
    font-weight: ${({ theme }) => theme.fontWeights[1]};
    color: ${({ theme }) => theme.colors.primary};
    line-height: ${({ theme }) => theme.lineHeights[2]};

    &::placeholder {
      color: ${({ theme }) => theme.colors.dove};
      font-weight: ${({ theme }) => theme.fontWeights[0]};
      font-style: italic;
    }

    &:focus {
      outline: none;
      color: #2d2d2d;
    }
  }

  #ai-prompt-wrapper div {
    box-shadow: none !important;
    background: transparent;
    border: none;
  }

  /* Glow Animation */
  @keyframes glow {
    100% {
      --glow-deg: 270deg;
    }
  }

  /* Glow Effect Pseudo-elements */
  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: inherit;
  }

  &::before {
    z-index: -1;
    background: transparent;
    inset: 0.25rem;
    scale: 1.05 1.05;
    transform-origin: center;
    filter: blur(var(--glow-size, 0.5rem));
  }
`;

export const AIButton = styled(Button)`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
    background: linear-gradient(135deg, #ccc 0%, #999 100%);
    box-shadow: none;
    opacity: 0.6;
  }
`;
